export default "__VITE_ASSET__CqufcIGz__"